<template>
  <div class="ContactNew">
    <h2 class="subtitle">
      Création d'un nouveau contact...
      <button class="button is-transparent is-loading">...</button>
    </h2>
  </div>
</template>

<script>
import { types as t } from "../../store/actions/contacts";

export default {
  name: "ContactNew",
  async mounted() {
    const contact = await this.$store.dispatch(t.ASK_NEW_CONTACT);
    setTimeout(() => {
      this.$router.push(`/contact/edit/${contact.uuid}`);
    });
  }
};
</script>

<style lang="scss">
.ContactNew {
}
</style>
